const PurchaseRoute = [
  {
    path: '/PurchaseXQ/:orderId',
    name: 'PurchaseXQ',
    component: () => import(/* webpackChunkName: "Purchase" */ '@/views/Index/components/Purchase/PurchaseXiangQing.vue'),
    meta: { title: '订单详情' }
  },
  {
    path: '/DeliverGood/:orderId',
    name: 'DeliverGood',
    component: () => import(/* webpackChunkName: "Purchase" */ '@/views/Index/components/Purchase/DeliverGoods.vue'),
    meta: { title: '订单发货' }
  },
  {
    path: '/PayLoading',
    name: 'PayLoading',
    component: () => import(/* webpackChunkName: "Purchase" */ '@/views/Index/components/Purchase/PayLoading.vue'),
    meta: { title: '支付' }
  },
  {
    path: '/PayV2Loading/:outTradeNo',
    name: 'PayV2Loading',
    component: () => import(/* webpackChunkName: "Purchase" */ '@/views/Index/components/Purchase/PayV2Loading.vue'),
    meta: { title: '支付' }
  }
]

export default PurchaseRoute
